import axios from "axios";
import { useState, useEffect } from "react";
import { API_BASE_URL } from "./constants";
import { api } from "./client";
import i18n from "../i18n";

export { api };

// Функція для входу користувача
export const loginUser = async (credentials) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/token/`, credentials);
        localStorage.setItem("access_token", response.data.access);
        localStorage.setItem("refresh_token", response.data.refresh);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: i18n.t("apiErrors.login") };
    }
};

// Функція для реєстрації користувача
export const registerUser = async (userData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/users/register/`, {
            ...userData,
            username: userData.email,
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: i18n.t("apiErrors.register") };
    }
};

// Функція для отримання даних поточного користувача
export const getUserProfile = async () => {
    try {
        const response = await api.get(`/users/me/`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Функція для виходу користувача
export const logoutUser = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    window.location.href = "/";
};

// Функція для оновлення профілю користувача
export const updateUserProfile = async (userData) => {
    try {
        let data = { ...userData };
        
        if (userData?.birth_date) {
            data.birth_date = userData.birth_date.format("DD.MM.YYYY");
        }

        if (userData?.phone_number) {
            data.phone_number = userData.phone_number.replace(/\s+/g, "");
        }

        const response = await api.put("/users/me/", data);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: i18n.t("apiErrors.updateProfile") };
    }
};

// Функція для підтвердження email (верифікація)
export const verifyEmail = async (token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/users/verify_email/`, {
            params: { token },
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: i18n.t("apiErrors.verifyEmail") };
    }
};

// Функція для отримання даних авторизованого користувача
export const useAuthUser = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const accessToken = localStorage.getItem("access_token");

        if (!accessToken) {
            setLoading(false);
            return;
        }

        const fetchUser = async () => {
            try {
                const userData = await getUserProfile();
                setUser(userData.user);
            } catch (err) {
                setError(i18n.t("apiErrors.loadUser"));
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, []);

    return { user, loading, error };
};


export const requestPasswordReset = async (email) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/users/password_reset/`,
            { email }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.error || error.response?.data?.detail || i18n.t("apiErrors.request")
        );
    }
};


export const confirmPasswordReset = async (token, password) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/users/password_reset_confirm/`,
            { token, password }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.error || error.response?.data?.detail || i18n.t("apiErrors.resetPassword")
        );
    }
};

export const changePassword = async (data) => {
    const response = await api.post(`/users/change_password/`,
        data
    );
    return response.data;
};
